<section class="relative flex flex-row-reverse overflow-hidden items-center py-[0.375rem] px-[0.75rem] justify-between gap-[0.75rem]">
  <p-button icon="true"
            severity="contrast"
            rounded="true"
            styleClass="!size-[1.75rem] !px-0 !py-0"
            [text]="true"
            (click)="close(true)">
    <svg-icon src="icons/icon-close-popup.svg" name="icon-close-popup" svgClass="!text-(--p-primary-200)"></svg-icon>
  </p-button>
  <span class="text-[0.75rem] flex gap-[0.25rem] items-center
    [&_.dialog-zoom-help-content]:bg-(--p-primary-50) [&_.dialog-zoom-help-content]:py-[0.25rem]
    [&_.dialog-zoom-help-content]:px-[0.375rem] [&_.dialog-zoom-help-content]:rounded
    [&_.dialog-zoom-help-content]:border-solid [&_.dialog-zoom-help-content]:border-[1px]
    [&_.dialog-zoom-help-content]:border-(--p-blue-100)"
    [innerHTML]="'@@dialog-zoom-help__content' | translate:{I18N_VAR_SCROLL_MODIFIER_KEY_TEXT: scrollModifierKeyText} | i18nTagFormat: dialogZoomHelpTagsConfig"
  >
  </span>
</section>
